// extracted by mini-css-extract-plugin
export var boxItems = "_b1-1";
export var boxItemsLg = "_b1-2";
export var button = "_b1-7";
export var buttonLg = "_b1-8";
export var filterGroupBox = "_b1-0";
export var icon = "_b1-3";
export var iconSecondary = "_b1-6";
export var iconWrapper = "_b1-4";
export var iconWrapperLg = "_b1-5";